// Mortgage Calculator Configuration
export const mortgageCalculatorConfig = {
  title: "Mortgage Calculator",
  inputs: [
    {
      id: "homePrice",
      title: "Home Price",
      format: "currency",
    },
    {
      id: "downPayment",
      title: "Down Payment",
      format: "currency",
    },
    {
      id: "annualInterestRate",
      title: "Annual Interest Rate",
      format: "percentage",
    },
    {
      id: "noOfYears",
      title: "Number of Years",
      format: "number",
    },
  ],
  outputs: [
    {
      id: "loanAmount",
      title: "Loan Amount",
      format: "currency",
    },
    {
      id: "payments",
      title: "Number of Payments",
      format: "number",
    },
    {
      id: "monthlyEmi",
      title: "Monthly Principal and Interest",
      format: "currency",
    },
  ],
};

// Mortgage Calculator Calculation Function
export const calculateMortgage = inputs => {
  const { homePrice, downPayment, annualInterestRate, noOfYears } = inputs;

  const monthlyInterestRate = annualInterestRate / 12 / 100;
  const loanAmount = homePrice - downPayment;
  const payments = noOfYears * 12;

  // Monthly EMI calculation using the formula from CSV
  const monthlyEmiNum =
    monthlyInterestRate *
    loanAmount *
    Math.pow(1 + monthlyInterestRate, payments);
  const monthlyEmiDenom =
    monthlyInterestRate === 0
      ? 1
      : Math.pow(1 + monthlyInterestRate, payments) - 1;

  let monthlyEmi;

  // Avoid running calculations when the divisor is 0, prevents returning Infinity
  if (monthlyInterestRate === 0) {
    monthlyEmi = payments === 0 ? 0 : loanAmount / payments;
  } else {
    monthlyEmi = noOfYears
      ? Math.round((monthlyEmiNum / monthlyEmiDenom) * 100) / 100
      : 0;
  }

  return {
    loanAmount,
    payments,
    monthlyEmi,
  };
};
